import sal from 'sal.js'

const useScrollAnimations = () => {
  sal({
    threshold: 0.2,
    once: true
  })
}

export default useScrollAnimations
